import { render, staticRenderFns } from "./vehicle.vue?vue&type=template&id=0260cf2a&scoped=true"
import script from "./vehicle.vue?vue&type=script&lang=js"
export * from "./vehicle.vue?vue&type=script&lang=js"
import style0 from "./vehicle.vue?vue&type=style&index=0&id=0260cf2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0260cf2a",
  null
  
)

export default component.exports